import React from 'react';
import Home from '../../logic/components/Home/Home';

export const HomeRoute = () => {
    return (
        <>  
            <Home />
        </>
    ) 
}